import styled from 'styled-components'

export const StyledEditor = styled.div`
  > .tox-tinymce {
    border: none;
  }
`
